import { Component, Input } from '@angular/core';
import { NoteBlock } from 'src/app/core/models/message-blocks';
import { MessageBlockBaseDirective } from '../../message-block-base.directive';

@Component({
  selector: 'app-mr-note',
  templateUrl: './mr-note.component.html',
  styleUrls: ['./mr-note.component.scss'],
})
export class MrNoteComponent extends MessageBlockBaseDirective {
  @Input() block!: NoteBlock;
}
